import React, {Component} from 'react'
import HelpTip from 'live/components/ui/help-tip'

class Description extends Component {
    render() {
        const {text = ""} = this.props
        if(typeof text != "string")
            return null
        return <HelpTip id="spanredirect" placement="top" unsafe={true} text={text}/>            
        
    }
}

export default Description;


